export enum ContentType {
  course = 'courses',
  lesson = 'lessons',
}

export enum ContentMode {
  all = 'all',
  content = 'content',
  test = 'test',
}

export enum ActivityMode {
  normal = 'normal',
  single = 'single',
  bite = 'bite',
}

export enum PostMessageType {
  closeActivity = 'closeActivity',
  updateActivityProgress = 'updateActivityProgress',
  requestTerminateActivityStart = 'RequestTerminateActivityStart',
  requestTerminateActivity = 'RequestTerminateActivity',
  terminateActivity = 'TerminateActivity',
}

export type PostMessage = {
  type: PostMessageType;
  data?: unknown;
};

export enum RemoteScormCommand {
  updateScore = 'lmsUpdateScore',
  finish = 'lmsFinish',
}

export type RemoteScormMessage = {
  Command: RemoteScormCommand;
  Score?: number;
  TestScore?: number;
};
